import React from 'react';
import { BookOpenIcon, CreditCardIcon, DownloadIcon } from 'lucide-react';
const assurances = [{
  label: 'Digitaler Download',
  Icon: DownloadIcon
}, {
  label: 'Einmalzahlung',
  Icon: CreditCardIcon
}, {
  label: '6 Fachbände',
  Icon: BookOpenIcon
}];
export function AssuranceRow({
  tone = 'light',
  className = ''
}: {
  tone?: 'light' | 'dark';
  className?: string;
}) {
  const text = tone === 'dark' ? 'text-brand-ivory/75' : 'text-brand-charcoal/60';
  const icon = tone === 'dark' ? 'text-brand-butter' : 'text-brand-forest';
  return <ul className={`flex flex-wrap justify-center gap-x-5 gap-y-2 ${className}`} role="list" data-id="element-44" data-mp="2zyuq12galpru">
      {assurances.map(({
      label,
      Icon
    }) => <li key={label} className={`flex items-center gap-1.5 font-body text-[12px] ${text}`} data-id="element-45" data-mp="39xtlfjc1roww">
          <Icon className={`h-3.5 w-3.5 ${icon}`} strokeWidth={2} aria-hidden="true" data-id="element-46" data-mp="1kim02qvsaswz" />
          {label}
        </li>)}
    </ul>;
}